import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  Input
} from '@angular/core';

@Component({
  selector: 'phx-summary',
  styleUrls: ['./phx-summary.scss'],
  templateUrl: './phx-summary.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'phx-summary',
    '[class.phx-summary-no-divider]': 'phxHideDivider'
  },
})
export class PhxSummaryComponent {
  /**
   * Controls whether to hide the right divider for this summary item.
   * When true, the divider is hidden. Default is false.
   */
  @Input() public phxHideDivider: boolean = false;
}

@Component({
  selector: 'phx-summary-value',
  template: `<ng-content></ng-content>`,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'phx-summary-value',
  },
})
export class PhxSummaryValueComponent { }

@Component({
  selector: 'phx-summary-label',
  template: `<ng-content></ng-content>`,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'phx-summary-label',
  },
})
export class PhxSummaryLabelComponent { }
